// Requirements summary:
// - Shared OTP digit helpers keep one-time-code autofill, paste, and manual
//   typing behavior consistent across segmented verification-code inputs.

export const OTP_CODE_LENGTH = 6;

export const createEmptyOtpCode = (length = OTP_CODE_LENGTH): string[] =>
  Array.from({ length }, () => '');

export const extractOtpDigits = (value: string, length = OTP_CODE_LENGTH): string[] => {
  const contiguousCode = value.match(new RegExp(`\\d{${length}}`))?.[0];
  const code = contiguousCode ?? value.replace(/\D/g, '').slice(0, length);

  return code.split('');
};

export const applyOtpDigits = (
  currentCode: string[],
  digits: string[],
  startIndex = 0,
): string[] => {
  const nextCode = [...currentCode];
  const writeFrom = digits.length >= nextCode.length ? 0 : startIndex;

  digits.slice(0, nextCode.length).forEach((digit, offset) => {
    const targetIndex = writeFrom + offset;
    if (targetIndex < nextCode.length) {
      nextCode[targetIndex] = digit;
    }
  });

  return nextCode;
};

export const getOtpFocusIndex = (
  currentCode: string[],
  digitCount: number,
  startIndex = 0,
): number => {
  if (digitCount <= 0) return startIndex;

  const writeFrom = digitCount >= currentCode.length ? 0 : startIndex;
  return Math.min(writeFrom + digitCount - 1, currentCode.length - 1);
};
